export default {"src":"/_next/static/media/x2.3e9272bd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};